// disable logging while running unit tests
const logLevel = window.isKarma || !window.envVars.clientDebug ? 'none' : (window.envVars.jsLogLevel || 'debug');

export const config = _.cloneDeep({
    cookies: {
        AUTH_TOKEN_HEADER: 'X-Urbn-Auth-Token',
        COOKIE_NAME_LANGUAGE: 'urbn_language',
        COOKIE_NAME_CURRENCY: 'urbn_currency',
        COOKIE_NAME_SITE_ID: 'urbn_site_id',
        COOKIE_NAME_INVENTORY_POOL: 'urbn_inventory_pool',
        COOKIE_NAME_AUTH_PAYLOAD: 'urbn_auth_payload',
        COOKIE_NAME_CHANNEL: 'urbn_channel'
    },

    log: {
        effects: false, // log redux effects actions?
        level: logLevel, // 'none', 'log', 'error', 'warn', 'info' or 'debug'
        redux: true // enable redux logging?
    },

    search: {
        debounce: 250
    },

    mainNavigation: {
        interval: 150,
        timeout: 50,
        tieredHoverNav: {
            exitTimeout: 250,
            enterTimeout: 250
        },
        level2Timeout: 250
    },

    ugc: {
        captionLimit: 500
    }
});

export default config;
